import { useEffect, useState } from 'react';

import useOnce from './useOnce';

import CRMApi from 'Api/CRM/CRMApi';
import { SelectOptions } from 'crm/elements/formElements/Select';

function useCountriesAndStates(country: string) {
    const [countries, setCountries] = useState<SelectOptions>({});
    const [states, setStates] = useState<SelectOptions>({});

    useOnce(() => CRMApi.get('countries').then((response) => setCountries(response.data)));

    useEffect(() => {
        if (country) {
            CRMApi.get(`states/${country}`).then((response) => setStates(response.data));
        } else {
            setStates({});
        }
    }, [country]);

    return [countries, states];
}

export default useCountriesAndStates;
